
import _ from 'lodash'
import { getCdnUrl, getResizedVideoUrl } from '~/scriptData/common/interM2'

export default {
  name: 'CommonVideo',
  props: {
    videoRef: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      default: ''
    },
    resize: {
      type: [Number, String],
      default: null
    },
    options: {
      type: Object,
      default: () => {
        return {}
      },
    },
    fastStart: {
      type: Boolean,
      default: false
    },
    videoClass: {
      type: String,
      default: ''
    },
    trimRange: {
      type: String,
      default: null
    },
    pauseVideo: {
      type: Function,
      default: () => {}
    },
    useMouseEvent: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      videoOptions: {
        muted: this.options.muted ?? null,
        loop: this.options.loop,
        playsinline: this.options.playsinline,
        playbackRates: this.options.playbackRates,
        bigPlayButton: true,
        poster: this.options.poster,
        autoplay: this.options.autoplay,
        controls: this.options.controls,
        sources: [
          {
            src: getCdnUrl(getResizedVideoUrl(this.src, this.resize, this.fastStart, 'webm', this.trimRange)),
            type: 'video/webm'
          },
          {
            src: getCdnUrl(getResizedVideoUrl(this.src, this.resize, this.fastStart, '', this.trimRange)),
            type: 'video/mp4'
          }
        ],
        controlBar: {
          playToggle: this.options.playToggle, // 플레이 버튼
          pictureInPictureToggle: this.options.pictureInPictureToggle, // 작은 창으로 새로 띄워(항상 위) 비디오 시청 가능
          remainingTimeDisplay: this.options.remainingTimeDisplay, // 남은시간 표기
          progressControl: this.options.progressControl, // 프로세스 컨트롤러 유무
          qualitySelector: this.options.qualitySelector, // 품질선택 창
        },
        errorDisplay: false,
        errorCode: 0
      },
    }
  },
  methods: {
    load () {
      this.$emit('load')
    },
    play (value) {
      if (this.useMouseEvent) {
        if (value) {
          this.$refs[this.videoRef].player.play()
        } else {
          this.$refs[this.videoRef].player.pause()
        }
      }
    },
    handleError (e) {
      const player = this.$refs[this.videoRef].player
      player.src({ src: getCdnUrl(getResizedVideoUrl(this.src, this.resize, this.fastStart, '')), type: 'video/mp4' })
      _.set(this.options.sources, 0, _.nth(this.options.sources, 1)) // [1] source를 [0]에 덮어씌움 (무한 재로딩 방지)
    }
  }
}
